import React from 'react';
import CRUDView, {CustomFilterFrame} from "../../../../../components/CRUDView";
import AppVariables from "../../../../../common/AppVariables";
import Utils, {exportFilteredCSV, findMediaWithTag} from "../../../../../common/Utils";
import {OwnerPaymentStatusMap, Permissions, TractorOwnerRequestPaymentStatus} from "../../../../../common/Constants";
import {
    VirtualCredit,
    FarmersEndpoints,
    PaymentsEndpoints,
    TractorOperatorEndpoint,
    TractorOwnerEndpoints,
    TractorsEndpoints
} from "../../../../../common/ProxyEndpoints";
import { Badge, Col, Row } from "reactstrap";
import StandardValue from "../../../../../common/StandardValue";
import {TimeRangeInfo, TimeRangeSelectionDialog} from "../../../../Request/RequestCommon";
import {ExpanderView, SectionedList} from "../../../../../components/AuditExplorer/Elements";
import CurrencyLabel from "../../../../../components/CurrencyLabel/CurrencyLabel";
import Icon from 'react-icons-kit/index';
import {ic_account_balance_wallet} from 'react-icons-kit/md/ic_account_balance_wallet';
import {ic_assignment} from 'react-icons-kit/md/ic_assignment';
import NumberLabel from "../../../../../components/NumberLabel/NumberLabel";
import history from '../../../../../history';
import {BankPaymentStatus} from "../Elements";
import Avatar from "../../../../../components/ProfileAvatar";
import {PaymentMediaTags} from "../Common";
import {getStatusFiltersForRole} from "../../../../Request/RequestStatusConfiguration";

//  Define properties which are searchable
const SearchProps = [
    'reference' ,
    'total_amount',
    'remaining_amount'
];

const PaymentStatus = [
    { label: "Active"  , value: "active" },
    { label: "Fully Utilized"  , value: "remaining_zero" },
    { label: "Not Verified"  , value: "not_verified" },
    { label: "Expired"  , value: "expired" },
    { label: "Idle (Pending)"  , value: "idle" },
    { label: "Disabled"  , value: "disabled" },
];

class Payments extends CRUDView {

    constructor(props) {
        super(props,'virtual_credit_payments');
    }

    itemDetailLink(item){
        return `/finance/credit/virtual/payment/detail/${item.id}`;
    }

    onExecuteRequest(url,params,{ filters }){

        const qs = params.query || (params.query = {});
        const {
            timeFrame,
            timeRangeStart,
            timeRangeEnd,
            statusFilter,
        } = filters;

        if(timeFrame){

            qs.filter_time_range = timeFrame;

            if(timeRangeStart)
                qs.range_from = timeRangeStart.toJSON();

            if(timeRangeEnd)
                qs.range_to = timeRangeEnd.toJSON();
        }

        if(statusFilter){
            qs.status_filter = statusFilter;
        }

    }

    getCustomFilterState(filters) {

    }

    beginShowDialog({ detailItem }) {
        history.push(this.itemDetailLink(detailItem));
    }

    /**
     * Sets the time range to display
     */
    setTimeRangeDisplay(opts){

        //
        const _update = {
            timeFrame: opts.range,
            timeRangeStart: opts.start ? opts.start.toJSON() : null,
            timeRangeEnd: opts.end ? opts.end.toJSON() : null
        };

        //
        this.setQueryFiltersRaw(filters => ({ ...filters, ..._update }));
    }

    renderDialogs(dialog) {

        const timeRangeInfo = this.state.timeRangeInfo || {};

        return <React.Fragment>

            {super.renderDialogs(dialog)}

            <TimeRangeSelectionDialog ref={r => this._timeRangeSelectionDlg = r}
                                      from={timeRangeInfo.start}
                                      to={timeRangeInfo.end}
                                      onApply={({ start , end }) => {

                                          this.setTimeRangeDisplay({
                                              range: "custom",
                                              start,
                                              end
                                          });

                                      }}/>
        </React.Fragment>
    }

    componentWillMount(){

        const me = this;
        this.setViewOptions({

            //  The message to show when there are no items in the view
            noRowsMessage: 'No payments added yet!',

            //  The class icon for the card header
            pageIcon: 'fa fa-credit-card',

            //  The title for the content frame
            pageTitle: 'Yolum (Payments)',

            //  The total number of items per page
            maxItemsPerPage: AppVariables.MaxItemsPerPage,

            //  Defines the features of the view
            features: [ 'toolbox' , 'search' ],

            multiSelection: {

                //  enable multi-selection
                enable : false,
            },

            hooks:{


            },

            //  defines (CRUD) actions enabled on the items
            actions:{

                //  create action options
                create: {
                    enabled: true,
                    text: 'Add Payment',
                    successCreateMsg: 'Payment added successfully',
                    failCreateMsg : 'Failed adding payment!',
                    editTitleMsg: 'Edit Payment',
                    createTitleMsg: 'Add Payment'
                },

                //  delete action options
                delete:{
                    enabled : false,
                },

                //  edit options
                edit:{
                    enabled : false
                }

            },

            queryActions: {

                //  The endpoint for query actions
                endpoint: VirtualCredit.getAllPayments().url
            },

            model: {

                include: [
                    'created_by',
                    'media',
                ]

            },

            inputs: [],

            filters: [
                {
                    key: 'statusFilter',
                    name: 'Status Filter',
                    query: "status_filter",
                    apply: false,
                    fromQuery: value => {

                        const _value = (value || "").toLowerCase();
                        if(PaymentStatus.find(x => x.value === _value))
                            return _value.toLowerCase();

                    },
                    renderValue: value => {

                        switch (value) {
                            case 'active':
                                return 'Active';
                            case 'remaining_zero':
                                return 'Fully Utilized';
                            case 'not_verified':
                                return 'Pending Verification';
                            case 'expired':
                                return 'Expired';
                            case 'idle':
                                return 'Idle';
                            case 'disabled':
                                return 'Disabled';
                        }

                    }
                }
            ],

            renderCustomFilters: (props) => null,

            search:{

                //
                placeholder: 'Search payments...',

                //  the mode for searching
                //  immediate: responsive
                //  explicit: wait till user hits the search button
                mode: 'explicit',

                //  The minimum characters to begin search with
                minSearchChars: 2,

                //  Search properties
                properties: SearchProps

            },

            //  Defines actions for toolbox
            toolBox: [
                {  text : 'Create Yolum Payment'  , icon : 'fa fa-plus'  , className: "btn-green"  , invoke: () =>  history.push('/finance/credit/virtual/create/payment'), position: 'right' , permissions: [ Permissions.VirtualCredit.Create ] },
                {  text : 'Refresh'  , icon : 'fa fa-refresh'  , invoke: () => me.refresh() , position: 'right' },
                {  text : 'Status',
                   icon: 'fa fa-signal'  , invoke: (index) => {
                        const filter = PaymentStatus[index].value;
                        return me.updateQuery('statusFilter',filter);
                   },
                   position: 'right' ,
                   group : 'status-filter' ,
                   items: PaymentStatus.map(x => x.label)
                },
                {
                    text: '', icon: 'fa fa-calendar',   items: Object.keys(TimeRangeInfo).map(x => TimeRangeInfo[x].label), position: 'left' , style: { marginRight: 10 } , invoke: index => {

                        let timeFrame = Object.keys(TimeRangeInfo)[index];
                        if (timeFrame === "custom") {

                            const filters = this.getQueryFilters();

                            //  show dialog for selecting time range
                            this._timeRangeSelectionDlg.show({
                                start: filters.timeRangeStart,
                                end: filters.timeRangeEnd
                            });

                            //  prevent selection of item
                            return false;

                        } else {
                            this.setTimeRangeDisplay({
                                range: timeFrame
                            });
                        }

                    }

                },
                {  text : ''  , icon : 'fa fa-gears' , invoke: (index) => {

                        switch (index){
                            case 0:
                                return exportFilteredCSV(VirtualCredit.exportPaymentsCSV(),{ component: me });
                        }

                    }, position: 'right' , group : 'more' ,
                    items: () => ([
                        <span><i className="fa fa-file-text"/> Export to CSV</span>
                    ]),
                    sticky: false,
                }
            ],

            // Describes the columns present in the table
            columns : [
                {   key: '__img' , label: ' ' , cell: (item,k) => <Avatar lightBoxImageTitle={"Document Photo"}
                                                                          round={false}
                                                                          src={findMediaWithTag(item.media,PaymentMediaTags.DocumentPhoto)}
                                                                          name={item.reference}
                                                                          size={32} /> , mobile: true },
                {   key: 'reference', label: () => me.sortCol("Reference","reference")},
                {   key: 'total_amount', label: me.sortCol("Total Amount","total_amount") , cell: (item) => <CurrencyLabel currency={item.currency} value={item.total_amount}/>, mobile: true },
                {   key: 'remaining_amount', label: me.sortCol("Remaining Amount","remaining_amount")  , cell: (item,key) => <CurrencyLabel currency={item.currency} value={item.remaining_amount}/>, mobile: true },
                {   key: 'utilized_amount', label: 'Utilized Amount' , cell: (item,key) => {
                        const amountUsed = item.total_amount - item.remaining_amount;
                        return <span><CurrencyLabel currency={item.currency} value={amountUsed}/> - {`(${(amountUsed / item.total_amount * 100).toFixed(2)}%)`}</span>
                    },
                    mobile: true
                },
                {   key: 'status', label: 'Status', cell: (item,key) =>  <BankPaymentStatus payment={item}/> ,mobile: true },
                {   key: 'date_created', label: () => me.sortCol("Created","date_created"), format: 'date', mobile: true },
            ],

            //  Describes details to show when clicked
            detailsDisplay: {
                enabled: true,
            },

            //  Processors
            processors :{

                //  create new item
                createItem: (proxy , payload) => {
                },

                //  on edit item
                onEditItem: (proxy,item, formData, affected ) => {
                },

                //  on delete item
                onDeleteItem: ( proxy,item) => {
                },

                //  called to delete many items
                deleteMany: (proxy,items) => {
                }

            }
        });

    }


}

export default Payments;



// WEBPACK FOOTER //
// ./src/views/Extras/Finance/VirtualCredit/Payments/Payments.js